export default {
    option: {
        value: 'label',
        label: 'Patient labeled as',

        children: [
            {
                value: 'label-includes',
                label: 'Patient labeled as',

                select: {
                    provider: 'label'
                },

                match: (patient, args) => (Array.isArray(patient.label) && args.some((arg) => patient.label.includes(arg)))
            }
        ]
    }
}
